// Localization config (Bolivia)

import { Localization } from '../../../shared/Localization';

import es from '../../generic/l10n/messages_es';
import en from '../../generic/l10n/messages_en';

const localization = new Localization('default_bo', es, [es, en]);

export default localization;
